export class IndexedDBFileSystem {
    constructor() {
        this.db = null;
        this.DB_NAME = 'amiron-fs';
        this.STORE_NAME = 'files';
    }
    async init() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.DB_NAME, 1);
            request.onerror = () => reject(request.error);
            request.onsuccess = () => {
                this.db = request.result;
                resolve();
            };
            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(this.STORE_NAME)) {
                    db.createObjectStore(this.STORE_NAME, { keyPath: 'path' });
                }
            };
        });
    }
    async readFile(path) {
        if (!this.db)
            throw new Error('FileSystem not initialized');
        const tx = this.db.transaction(this.STORE_NAME, 'readonly');
        const store = tx.objectStore(this.STORE_NAME);
        const request = store.get(path);
        return new Promise((resolve, reject) => {
            request.onsuccess = () => {
                const result = request.result;
                if (result) {
                    resolve(result.data);
                }
                else {
                    reject(new Error(`File not found: ${path}`));
                }
            };
            request.onerror = () => reject(request.error);
        });
    }
    async writeFile(path, data) {
        if (!this.db)
            throw new Error('FileSystem not initialized');
        const tx = this.db.transaction(this.STORE_NAME, 'readwrite');
        const store = tx.objectStore(this.STORE_NAME);
        const request = store.put({
            path,
            data,
            modified: new Date(),
        });
        return new Promise((resolve, reject) => {
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }
    async listDir(path) {
        if (!this.db)
            throw new Error('FileSystem not initialized');
        const tx = this.db.transaction(this.STORE_NAME, 'readonly');
        const store = tx.objectStore(this.STORE_NAME);
        const request = store.getAll();
        return new Promise((resolve, reject) => {
            request.onsuccess = () => {
                const results = request.result;
                const entries = results
                    .filter((item) => item.path.startsWith(path))
                    .map((item) => ({
                    name: item.path.split('/').pop() || '',
                    type: 'file',
                    size: item.data.length,
                    created: new Date(item.modified),
                    modified: new Date(item.modified),
                }));
                resolve(entries);
            };
            request.onerror = () => reject(request.error);
        });
    }
    async createDir(path) {
        // IndexedDB doesn't need explicit directory creation
        return Promise.resolve();
    }
    async deleteFile(path) {
        if (!this.db)
            throw new Error('FileSystem not initialized');
        const tx = this.db.transaction(this.STORE_NAME, 'readwrite');
        const store = tx.objectStore(this.STORE_NAME);
        const request = store.delete(path);
        return new Promise((resolve, reject) => {
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }
}
